module.exports = __webpack_public_path__ + "img/koh_protective_hide.2040949d.png";